import React, { useState, useRef, useEffect } from 'react';
import ResponsiveMenu from './ResponsiveMenu';
import styles from './Header.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { buildWhatsAppCartUrl } from '../utils/whatsapp';

const Header = ({ cartItems = 0, cartList = [], cartTotal = 0, showCartDropdown = false, onCartToggle = () => {}, onRemoveItem = () => {} }) => {
    const cartRef = useRef(null);
    const userRef = useRef(null);
    const menuButtonRef = useRef(null);
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState("");
    const [name, setname] = useState("");
    const [searchText, setSearchText] = useState("");
    const [showSearchBox, setShowSearchBox] = useState(false);
    const [localCartDropdown, setLocalCartDropdown] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showLocationModal, setShowLocationModal] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setIsLoggedIn(true);
            try {
                const decoded = jwtDecode(token);
                console.log('Decoded token:', decoded);
                setUsername(decoded.username || "");
                setname(decoded.name || decoded.fullname || decoded.username || "");

            } catch (e) {
                setUsername("");
                setname("");
            }
        } else {
            setIsLoggedIn(false);
            setUsername("");
            setname("");

        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close cart dropdown when clicking outside
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                if (localCartDropdown) {
                    setLocalCartDropdown(false);
                }
            }
            // Close user menu when clicking outside
            if (userRef.current && !userRef.current.contains(event.target)) {
                if (showUserMenu) {
                    setShowUserMenu(false);
                }
            }
            // Close search box when clicking outside
            if (showSearchBox && !event.target.closest('.search-container')) {
                setShowSearchBox(false);
            }
            // Close mobile menu when clicking outside (but not on the menu button itself)
            if (isMenuOpen && 
                menuButtonRef.current && 
                !menuButtonRef.current.contains(event.target) &&
                !event.target.closest('.navbar')) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [localCartDropdown, showSearchBox, showUserMenu, isMenuOpen]);

    const handleLoginClick = () => {
        navigate('/login');
    };

    const handleLogoutClick = () => {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUsername("");
        navigate('/');
    };

    const handleSearchIconClick = () => {
        setShowSearchBox(!showSearchBox);
    };

    const handleSearchInputChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchText.trim() !== '') {
            navigate(`/search?query=${encodeURIComponent(searchText.trim())}`);
            setShowSearchBox(false);
            setSearchText('');
        }
    };

    return (
        <div id={styles.topHeader}>
            {/* Top Bar */}
            <div className={styles.topBar}>
                <div className={styles.marquee}>
                    <div className={styles.marqueeTrack}>
                        <span className={styles.marqueeItem}>Panaromax Cases &nbsp;-&nbsp; 70412000 &nbsp;-&nbsp; FurnChebak-Crepaway building - 2nd floor</span>
                        <span className={styles.marqueeItem} aria-hidden="true">Panaromax Cases &nbsp;-&nbsp; 70412000 &nbsp;-&nbsp; FurnChebak-Crepaway building - 2nd floor</span>
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <div className={styles.mainHeader}>
                <div className={styles.headerContainer}>
                    {/* Logo */}
                    <div className={styles.logoSection}>
                        <Link to="/" className={styles.logoLink}>
                            <img src="/img/logo1.png" alt="Logo" className={styles.logoImage} />
                        </Link>
                    </div>

                    {/* Search */}
                    <div className={styles.searchSection}>
                        <form onSubmit={handleSearchSubmit} className={styles.searchForm}>
                            <input
                                type="text"
                                value={searchText}
                                onChange={handleSearchInputChange}
                                placeholder="Search for products"
                                className={styles.searchInput}
                            />
                            <button type="submit" className={styles.searchButton}>
                                <i className="fa fa-search"></i>
                            </button>
                        </form>
                    </div>

                    {/* Right Icons */}
                    <div className={styles.rightSection}>
                        {/* Location */}
                        <button
                            className={styles.iconButton}
                            onClick={() => setShowLocationModal(true)}
                        >
                            <i className="fa fa-map-marker"></i>
                            <span>Location</span>
                        </button>

                        {/* Wishlist */}
                      

                        {/* User */}
                        {!isLoggedIn ? (
                            <button onClick={handleLoginClick} className={styles.iconButton}>
                                <i className="fa fa-user"></i>
                            </button>
                        ) : (
                            <div className={styles.userDropdown} ref={userRef}>
                                <button
                                    onClick={() => setShowUserMenu(!showUserMenu)}
                                    className={styles.iconButton}
                                >
                                <i className="fa fa-user"></i>
                                </button>
                                {showUserMenu && (
                                    <div className={styles.userMenu}>
                                        <div className={styles.userInfo}>
                                            <h6>{name}</h6>
                                            <small></small>
                                        </div>
                                        <Link
                                            to="/profile"
                                            className={styles.userMenuItem}
                                            onClick={() => setShowUserMenu(false)}
                                        >
                                            Profile
                                        </Link>
                                        <button
                                            onClick={() => {
                                                handleLogoutClick();
                                                setShowUserMenu(false);
                                            }}
                                            className={styles.userMenuItem}
                                        >
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Cart */}
                        <div className={styles.cartSection} ref={cartRef}>
                            <button
                                onClick={() => setLocalCartDropdown(!localCartDropdown)}
                                className={styles.cartButton}
                            >
                                <i className="fa fa-shopping-cart"></i>
                                <span className={styles.cartBadge}>{cartItems}</span>
                            </button>

                            {localCartDropdown && (
                                <div className={styles.cartDropdown}>
                                    {cartList.length > 0 ? (
                                        <>
                                            {cartList.map((item, index) => (
                                                <div key={index} className={styles.cartListItem}>
                                                    <img src={item.photo_url} alt={item.item_name} className={styles.cartListItemImage}/>
                                                    <div>
                                                        <div className={styles.cartListItemInfo}>{item.item_name}</div>
                                                        <div className={styles.cartListItemPrice}>{item.sell_price > 0 ? `$${item.sell_price} x ${item.quantity || 1}` : `x ${item.quantity || 1}`}</div>
                                                    </div>
                                                    <button
                                                        onClick={() => onRemoveItem(index)}
                                                        className={styles.cartListItemRemoveButton}
                                                        aria-label={`Remove ${item.item_name} from cart`}
                                                    >
                                                        <i className="fa fa-close"></i>
                                                    </button>
                                                </div>
                                            ))}
                                            <div className={styles.cartTotal}>
                                                <span>Total:</span>
                                                <span>{cartTotal > 0 ? `$${cartTotal}` : ''}</span>
                                            </div>
                                            <div className={styles.cartLinks}>
                                                <Link to="/cart" className={`${styles.cartLink} ${styles.cartLinkView}`}>
                                                    View Cart
                                                </Link>
                                                <a
                                                    href={buildWhatsAppCartUrl(cartList)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={`${styles.cartLink} ${styles.cartLinkWhatsapp}`}
                                                >
                                                    <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp
                                                </a>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6b7280' }}>
                                            <i className="fa fa-shopping-cart" style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}></i>
                                            <p>Your cart is empty</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Mobile Menu Toggle Button */}
                        <button 
                            ref={menuButtonRef}
                            className={styles.mobileMenuButton}
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            <i className={`fa fa-${isMenuOpen ? 'times' : 'bars'}`}></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* Navigation Menu */}
            <ResponsiveMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

            {/* Location Modal */}
            {showLocationModal && (
                <div
                    className={styles.locationModalOverlay}
                    onClick={() => setShowLocationModal(false)}
                >
                    <div
                        className={styles.locationModal}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={styles.locationModalHeader}>
                            <h5>Our Location</h5>
                            <button
                                className={styles.locationModalClose}
                                onClick={() => setShowLocationModal(false)}
                                aria-label="Close"
                            >
                                <i className="fa fa-close"></i>
                            </button>
                        </div>
                        <iframe
                            title="Panaromax Cases Location"
                            src="https://www.google.com/maps?q=33.868337,35.525786&z=17&output=embed"
                            className={styles.locationModalMap}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                        <a
                            href="https://maps.app.goo.gl/khHQENThyyjEFX9p7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.locationModalLink}
                        >
                            Open in Google Maps
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Header;
